export default __webpack_public_path__ + "static/media/ProximaNova-LightItalic.b9c07870.otf";